module.exports = __webpack_public_path__ + "static/media/22.b896b0f1.jpg";